import { render, staticRenderFns } from "./ReportsCard.vue?vue&type=template&id=7dc462f0&scoped=true"
import script from "./ReportsCard.vue?vue&type=script&lang=js"
export * from "./ReportsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc462f0",
  null
  
)

export default component.exports